import { Type } from 'class-transformer';
import { Model } from './model';
import { Invoice, Organization, Partner } from '.';

export interface FeeItem {
  id: string;
  label: string;
  amount: number;
}

export interface ItemGroup<T> {
  name: string;
  items: T[];
  subtotal: number;
  isExpandable: boolean;
  isExpanded?: boolean;
}

export enum CheckoutMode {
  Collect = 'collect',
  Review = 'review',
  Processing = 'processing',
  Complete = 'complete',
  Error = 'error',
  PendingVerification = 'pending_verification',
}

export class Checkout extends Model {
  @Type(() => Invoice)
  invoices: Invoice[];
  organization: Organization;
  partner: Partner;
  currency: string;
  total: number;
  subtotal: number;
  surcharge: number;
  mode?: CheckoutMode;
  portal_url?: string;
}
